import Api from 'api/api';

class FamilyApi {
    my() {
        return Api.get('/family/my');
    }

    create() {
        return Api.post('/family');
    }

    memberAdd({email}) {
        return Api.post('/family/members', {
            email
        });
    }

    memberRemove(familyMemberId) {
        return Api.delete(`/family/members/${familyMemberId}`);
    }
}

export default new FamilyApi();


// WEBPACK FOOTER //
// ./src/api/family.js